import React from 'react';

const OurApprovals: React.FC = () => (
  <div className="static-page">
    <h1>Our Approvals</h1>
    <p>We have secured thousands of approvals for EB1A, EB1B, EB2-NIW, O1, and other immigration petitions. Our success stories reflect our commitment to excellence and client satisfaction.</p>
  </div>
);

export default OurApprovals;
